// export const FETCH_USER = 'fetch_user';
// export const FETCH_SURVEYS = 'fetch_surveys';
export const CHANGE_AUTH = 'login_user';
export const FETCH_USER_INFO = 'fetch_user_info';
export const FETCH_CUSTOM_SITE = 'fetch_custom_site';
export const CONNECT_SOCKET = 'connect_socket';
export const DISCONNECT_SOCKET = 'disconnect_socket';
